import React from 'react';
import { Eyebrow, Button } from './UI';
import { AutoVideo } from './AutoVideo';
import { Phone, Mail, Clock, MessageCircle, Send } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="relative py-[120px] overflow-hidden" data-id="element-77">
      {/* Background Video */}
      <div className="absolute inset-0 z-0" data-id="element-78">
        <AutoVideo src="https://cdn.magicpatterns.com/uploads/fWKrLziAYDyxUuYVynDRTi/hf_20260506_151534_e280cd37-1545-428a-a30c-8bf31ff2eab2.mp4" className="w-full h-full object-cover opacity-100" data-id="element-79" />
        {/* Dark overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-base-black/90 via-base-black/40 to-base-black/90" data-id="element-80"></div>
        <div className="absolute inset-0 bg-patriot-navy/10 mix-blend-overlay" data-id="element-81"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <Eyebrow data-id="element-84">DIRECT COMMS</Eyebrow>
          <h2 className="text-5xl md:text-[64px] leading-[0.9] mb-4" data-id="element-85">
            REACH THE{' '}
            <span className="text-acid-green" data-id="element-86">BLACKOUT UNIT TEAM.</span>
          </h2>
          <p className="font-barlow text-lg text-text-body max-w-2xl mx-auto" data-id="element-87">
            Real operators. Real answers. No bots. No wait. We respond to every
            single message.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-16" data-id="element-88">
          {/* Left - Info */}
          <div className="w-full lg:w-1/2" data-id="element-89">
            <p className="font-barlow text-[17px] text-text-body leading-[1.9] mb-10" data-id="element-90">
              "We're a team of operators and builders — not a faceless customer
              service department. When you contact BLACKOUT UNIT, a real person
              responds. Every time."
            </p>

            <div className="space-y-6 mb-10" data-id="element-91">
              <div className="flex items-start gap-4" data-id="element-92">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-93">
                  <Phone size={20} data-id="element-94" />
                </div>
                <div data-id="element-95">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-96">
                    CALL DIRECT
                  </div>
                  <a href="tel:+13055550142" className="font-bebas text-2xl text-white hover:text-acid-green transition-colors" data-id="element-97">
                    +1 (305) 555-0142
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-98">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-99">
                  <Mail size={20} data-id="element-100" />
                </div>
                <div data-id="element-101">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-102">
                    EMAIL SUPPORT
                  </div>
                  <a href="mailto:support@blackoutunit.com" className="font-bebas text-2xl text-white hover:text-acid-green transition-colors" data-id="element-103">
                    support@blackoutunit.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-104">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-105">
                  <Clock size={20} data-id="element-106" />
                </div>
                <div data-id="element-107">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-108">
                    HOURS OF OPERATION
                  </div>
                  <div className="font-inter text-sm text-white" data-id="element-109">
                    Mon–Fri: 9AM–7PM ET
                    <br data-id="element-110" />
                    Saturday: 10AM–4PM ET
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-111">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-112">
                  <MessageCircle size={20} data-id="element-113" />
                </div>
                <div data-id="element-114">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-115">
                    LIVE CHAT
                  </div>
                  <div className="font-inter text-sm text-white" data-id="element-116">
                    Available on this page — bottom right
                    <br data-id="element-117" />
                    <span className="text-text-dimmed" data-id="element-118">
                      Average response: under 3 minutes
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#4CAF50]/10 border border-[#4CAF50]/20 p-4 flex items-start gap-3" data-id="element-119">
              <div className="text-[#4CAF50] font-bold mt-0.5" data-id="element-120">✓</div>
              <div data-id="element-121">
                <div className="font-barlow font-bold text-xs text-[#4CAF50] tracking-[2px] uppercase mb-1" data-id="element-122">
                  AVERAGE RESPONSE TIME
                </div>
                <div className="font-inter text-xs text-text-dimmed" data-id="element-123">
                  "Under 2 hours during business hours. Same-day response
                  guaranteed Mon–Fri."
                </div>
              </div>
            </div>
          </div>

          {/* Right - Form */}
          <div className="w-full lg:w-1/2" data-id="element-124">
            <div className="bg-dark-1 border border-dark-3 p-8 md:p-10" data-id="element-125">
              <h3 className="font-bebas text-2xl text-white mb-6" data-id="element-126">
                SEND INTEL
              </h3>
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-127">
                <div className="grid grid-cols-2 gap-4" data-id="element-128">
                  <input type="text" placeholder="First Name" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-129" />
                  <input type="text" placeholder="Last Name" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-130" />
                </div>
                <input type="email" placeholder="Email Address" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-131" />
                <input type="tel" placeholder="Phone (optional)" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-132" />

                <div className="relative" data-id="element-133">
                  <select className="w-full bg-base-black border border-dark-3 p-3 text-text-dimmed font-inter text-sm focus:border-acid-green outline-none transition-colors appearance-none cursor-pointer" data-id="element-134">
                    <option value="" disabled selected data-id="element-135">
                      Select Subject...
                    </option>
                    <option value="order" data-id="element-136">Order Status</option>
                    <option value="product" data-id="element-137">Product Question</option>
                    <option value="warranty" data-id="element-138">Warranty Claim</option>
                    <option value="return" data-id="element-139">Return / Exchange</option>
                    <option value="wholesale" data-id="element-140">Wholesale Inquiry</option>
                    <option value="other" data-id="element-141">Other</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-text-dimmed" data-id="element-142">
                    ▼
                  </div>
                </div>

                <textarea placeholder="Message" rows={4} className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors resize-none" data-id="element-143"></textarea>

                <Button variant="primary" fullWidth className="mt-4" data-id="element-144">
                  <span className="inline-flex items-center justify-center gap-2" data-id="element-145">
                    <Send size={14} strokeWidth={2.5} data-id="element-146" />
                    SEND MESSAGE
                  </span>
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
};